import { Avatar } from '@mentimeter/visualizations-react/components/identified-responses';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { useTranslations } from 'next-intl';

interface Identity {
  displayName: string;
  id: string;
}

export interface IdentitiesListProps {
  identities: Identity[];
  title: string;
  color: string;
  totalResponses: number;
}

export const IdentitiesList = ({
  identities,
  title,
  color,
  totalResponses,
}: IdentitiesListProps) => {
  const translate = useTranslations('presenting.legacy');
  const identitiesCount = identities.length;

  return (
    <Box bg="surfaceSunken" borderRadius="2xl" width="400px" p="space8">
      <Text
        fontWeight="regular"
        fontSize="150"
        color="text"
        pr="space10"
        lineHeight="tight"
        style={{
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {title}
      </Text>
      <Text fontSize="125" color="textWeaker">
        {translate(
          totalResponses === 1
            ? 'identified_results.name_count_singular'
            : 'identified_results.name_count_plural',
          {
            nrOfNames: `${totalResponses}`,
          },
        )}
      </Text>
      <Box
        mt="space5"
        pt="space5"
        width="100%"
        overflow="scroll"
        borderStyle="solid"
        borderTopWidth="1px"
        borderColor="border"
        alignItems="center"
        flex="1"
        maxHeight="416px"
      >
        {identities.map((identity) => (
          <IdentitiesListItem
            key={identity.id}
            name={identity.displayName}
            color={color}
          />
        ))}
        {identities.length < totalResponses && (
          <Text
            fontSize="100"
            color="textWeaker"
            py="space5"
            textAlign="center"
          >
            {translate('identified_results.limited_names_message_part_1', {
              nrOfNames: `${identitiesCount}`,
            })}
            <br />
            {translate('identified_results.limited_names_message_part_2')}
          </Text>
        )}
      </Box>
    </Box>
  );
};

const IdentitiesListItem = ({
  name,
  color,
}: {
  name: string;
  color: string;
}) => {
  return (
    <Box
      flexDirection="row"
      py="space2"
      gap="space3"
      alignItems="center"
      width="100%"
    >
      <Avatar color={color}>{name.charAt(0).toUpperCase()}</Avatar>
      <Text fontSize="125" color="textWeak" style={{ wordBreak: 'break-word' }}>
        {name}
      </Text>
    </Box>
  );
};
